import { mq } from '@/styles'
import { LANG_COUNTRY, STORE_ABBR } from '@/utils'
import { type FC } from 'react'
import styled from 'styled-components'

const SOCIAL_ICONS = {
  instagram: () => <svg aria-hidden='true' xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30' fillRule='evenodd'><circle fill='var(--color-text)' cx='15' cy='15' r='15' /><path d='M17.871 15a2.871 2.871 0 1 1-5.742 0 2.87 2.87 0 1 1 5.742 0h0zm3.843-5.08a2.85 2.85 0 0 0-1.634-1.634c-.304-.117-.762-.258-1.6-.296L15 7.939l-3.48.05c-.84.039-1.296.176-1.6.297A2.85 2.85 0 0 0 8.285 9.92c-.117.304-.258.762-.296 1.6L7.938 15l.05 3.481c.039.84.176 1.296.296 1.599.29.751.884 1.345 1.635 1.635.304.117.762.258 1.6.296l3.48.05 3.48-.05c.84-.038 1.296-.179 1.6-.296a2.85 2.85 0 0 0 1.634-1.635c.117-.304.258-.762.297-1.599L22.06 15l-.05-3.48c-.039-.84-.179-1.296-.297-1.6zM15 19.423c-2.443 0-4.423-1.98-4.423-4.423s1.98-4.423 4.423-4.423 4.423 1.98 4.423 4.423c0 1.173-.466 2.298-1.295 3.127S16.173 19.423 15 19.423zm4.598-7.987c-.418 0-.795-.252-.955-.638a1.03 1.03 0 0 1 .224-1.126c.296-.295.74-.384 1.126-.224s.638.537.638.955c0 .571-.463 1.034-1.034 1.034h0zM15 0C6.717 0 0 6.717 0 15s6.717 15 15 15 15-6.717 15-15S23.283 0 15 0zm8.561 18.551c-.042.916-.187 1.543-.4 2.091-.447 1.157-1.362 2.072-2.52 2.52-.548.213-1.172.359-2.091.4s-1.211.052-3.551.052-2.633-.01-3.551-.052-1.543-.187-2.091-.4a4.41 4.41 0 0 1-2.52-2.52c-.213-.548-.359-1.172-.4-2.091s-.05-1.212-.05-3.551l.052-3.551c.042-.919.187-1.543.4-2.091a4.41 4.41 0 0 1 2.52-2.52c.548-.213 1.172-.359 2.091-.4s1.212-.052 3.551-.052 2.633.01 3.551.052 1.543.188 2.091.4a4.41 4.41 0 0 1 2.52 2.52c.213.548.359 1.172.401 2.091s.051 1.212.051 3.551l-.052 3.551z' fill='var(--color-background)' fillRule='nonzero' /></svg>,
  facebook: () => <svg aria-hidden='true' xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path d='M15 0C6.716 0 0 6.716 0 15s6.716 15 15 15 15-6.716 15-15S23.284 0 15 0zm3.022 10.762h-1.641c-.27 0-.648.134-.648.708v1.528h2.285l-.271 2.594h-2.016v6.217h-3.056v-6.217h-1.453v-2.596h1.453v-1.68c0-1.202.571-3.083 3.083-3.083l2.263.009v2.521z' fill='var(--color-background)' /></svg>,
  linkedin: () => <svg aria-hidden='true' xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path
    d='M15 0c8.284 0 15 6.716 15 15s-6.716 15-15 15S0 23.284 0 15 6.716 0 15 0zm-3.506 12.432H8.396v9.316h3.097v-9.316zm7.602-.221c-1.643 0-2.381.903-2.791 1.538h0v-1.32h-3.097c.011.241.016 1.062.018 2.123v1.589l-.016 5.337-.001.168v.054.045h3.097v-5.204c0-.278.021-.557.102-.756.224-.556.734-1.133 1.589-1.133 1.121 0 1.569.857 1.569 2.109h0v4.985h3.096l.001-5.344c0-2.862-1.528-4.194-3.565-4.194zm-9.13-4.273c-1.059 0-1.752.696-1.752 1.61 0 .894.672 1.61 1.711 1.61h0 .021c1.08 0 1.752-.715 1.752-1.61-.02-.915-.672-1.61-1.731-1.61z'
    fill='var(--color-background)' /></svg>,
  youtube: () => <svg aria-hidden='true' xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30' fill='var(--color-background)'><path d='M15 0C6.716 0 0 6.716 0 15s6.716 15 15 15 15-6.716 15-15S23.284 0 15 0zm7.46 18.559a1.87 1.87 0 0 1-1.385 1.592c-.358.107-.742.138-1.117.171-.582.05-1.167.086-1.752.103l-3.196.062h-.018c-1.065.003-2.131-.032-3.196-.062-.586-.017-1.172-.053-1.752-.103-.376-.032-.762-.064-1.117-.171a1.87 1.87 0 0 1-1.385-1.592c-.285-1.673-.342-3.359-.234-5.048a19.11 19.11 0 0 1 .276-2.262c.154-.752.759-1.328 1.518-1.445a15 15 0 0 1 1.788-.184l3.995-.106h.234c1.332.009 2.664.051 3.995.106a15 15 0 0 1 1.788.184c.759.117 1.364.694 1.518 1.446a19.11 19.11 0 0 1 .276 2.262c.108 1.688.052 3.374-.233 5.047zm-9.017-1.209l4.035-2.344-4.035-2.35z' /></svg>,
  tiktok: () => <svg aria-hidden='true' xmlns='http://www.w3.org/2000/svg' width='30' height='30'><path d='M15 30a15 15 0 1 0 0-30 15 15 0 1 0 0 30zm6.72-16.5a4.2 4.2 0 0 1-3.9-1.88v6.46c0 2.64-2.14 4.77-4.77 4.77s-4.77-2.14-4.77-4.77 2.14-4.77 4.77-4.77c.1 0 .2.01.3.02v2.35l-.3-.03c-1.35 0-2.44 1.09-2.44 2.44s1.09 2.44 2.44 2.44 2.53-1.06 2.53-2.41l.02-10.97h2.25a4.2 4.2 0 0 0 3.86 3.74v2.61z' fill='var(--color-background)' /></svg>
}

const SOCIAL_LINKS = {
  mmf: {
    'es-ES': {
      instagram: 'https://www.instagram.com/mammafiore_official/',
      facebook: 'https://www.facebook.com/mammafiore',
      linkedin: 'https://es.linkedin.com/company/mammafiore',
      youtube: 'https://www.youtube.com/@mammafiore_official',
      // tiktok: 'https://www.tiktok.com/@hellomamma_es',
    },
    'fr-FR': {
      instagram: 'https://www.instagram.com/mammafiore_official/',
      facebook: 'https://www.facebook.com/mammafiore',
      linkedin: 'https://es.linkedin.com/company/mammafiore',
      youtube: 'https://www.youtube.com/@mammafiore_official',
      // tiktok: 'https://www.tiktok.com/@hellomamma_fr',
    },
    'en-GB': {
      instagram: 'https://www.instagram.com/mammafiore_official/',
      facebook: 'https://www.facebook.com/mammafiore',
      linkedin: 'https://es.linkedin.com/company/mammafiore',
      youtube: 'https://www.youtube.com/@mammafiore_official',
      // tiktok: 'https://www.tiktok.com/@hellomamma_en',
    },
    'de-DE': {
      instagram: 'https://www.instagram.com/mammafiore_official/',
      facebook: 'https://www.facebook.com/mammafiore',
      linkedin: 'https://es.linkedin.com/company/mammafiore',
      youtube: 'https://www.youtube.com/@mammafiore_official',
      // tiktok: 'https://www.tiktok.com/@hellomamma_de',
    },
    'pt-PT': {
      instagram: 'https://www.instagram.com/mammafiore_official/',
      facebook: 'https://www.facebook.com/mammafiore',
      linkedin: 'https://es.linkedin.com/company/mammafiore',
      youtube: 'https://www.youtube.com/@mammafiore_official',
      // tiktok: 'https://www.tiktok.com/@hellomamma_pt',
    }
  },
  hm: {
    'es-ES': {
      facebook: 'https://www.facebook.com/HelloMamma-103977235287577',
      instagram: 'https://www.instagram.com/hellomamma_es/',
      tiktok: 'https://www.tiktok.com/@hellomamma_es',
      youtube: 'https://www.youtube.com/channel/UCxTmZo714A8Fa6YWWOO64lA',
      linkedin: 'https://www.linkedin.com/company/hellomamma',
    },
    'en-GB': {
      facebook: 'https://www.facebook.com/HelloMamma-103977235287577',
      instagram: 'https://www.instagram.com/hellomamma_uk/',
      tiktok: 'https://www.tiktok.com/@hellomamma_es',
      youtube: 'https://www.youtube.com/channel/UCxTmZo714A8Fa6YWWOO64lA',
      linkedin: 'https://www.linkedin.com/company/hellomamma',
    },
    'fr-FR': {
      facebook: 'https://www.facebook.com/HelloMamma-103977235287577',
      instagram: 'https://www.instagram.com/hellomamma_fr/',
      tiktok: 'https://www.tiktok.com/@hellomamma_es',
      youtube: 'https://www.youtube.com/channel/UCxTmZo714A8Fa6YWWOO64lA',
      linkedin: 'https://www.linkedin.com/company/hellomamma',
    }
  }
}

const getItems = () => {
  const data = SOCIAL_LINKS[STORE_ABBR][LANG_COUNTRY]
  return Object.keys(data).map((keyname, idx) => {
    const href = data[keyname]
    return <li key={idx}>
      <a href={href} target='_blank' rel='noopener noreferrer' aria-label={`${keyname} (Opens in new tab)`}>
        {SOCIAL_ICONS[keyname]()}
      </a>
    </li>
  })
}

export const SocialMedia:FC = () => {
  const Items = getItems()
  return (
    <Nav aria-labelledby='footer-social-media'>
      <h2 id='footer-social-media' className='srt-only'>Follow Us</h2>
      <ul>
        {Items}
      </ul>
    </Nav>
  )
}

const Nav = styled.nav`
  ${mq.greaterThan('tablet')} {
    width: 49%;
  }

  > ul {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 10px;
    justify-content: center;

    ${mq.greaterThan('tablet')} {
      gap: 15px;
      justify-content: flex-start;
    }
  }

  a {
    opacity: .6;
    transition: opacity 250ms ease;

    &:hover {
      opacity: 1;
    }
  }
`
